export const baseConfig = {
    client: `Service`,
    title: `Getac Service`,
    description: `gusa rma mgmt sys`,
    logoUrl: `/assets/logos/getac-logo.svg`
}
